// extracted by mini-css-extract-plugin
export default {"requestListMobile":"request-list-mobile_requestListMobile__lsHgJ","vendorsLength":"request-list-mobile_vendorsLength__piEmc","vendorsInfo":"request-list-mobile_vendorsInfo__Z2q0a"};